import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface CardWrapperProps {
  children: React.ReactNode
  title: string
  subtitle: string
}

export const CardWrapper = ({
  children,
  title,
  subtitle,
}: CardWrapperProps): JSX.Element => {  
  return (
    <S.Container>
      <S.WrapperTitle>
        <Typography weight='bold' variant="content1">{title}</Typography>
        <Typography customClassName='subtitle' variant="content3">{subtitle}</Typography>
      </S.WrapperTitle>
      {children}
    </S.Container>
  )
}